import Glide from '@glidejs/glide';
class slider{
	constructor() {
		
	}
	create(el) {
		let slider = new Glide(el, {
			perView: parseInt(el.getAttribute('data-desktop-slides')),
			type: el.getAttribute('data-type'),
			startAt: 1,
			autoplay: 7000,
			focusAt: 'center',
			breakpoints: {
				800: {
					perView: 1,
				}
			},
		});
		slider.on('mount.after', () => {
			let track = el.querySelector('.glide__track .glide__slides');
			let slides = Array.from(track.children);
			let tallestSlide = null;
			slides.forEach(slide => {
				if (!tallestSlide || slide.offsetHeight > tallestSlide.offsetHeight) {
					tallestSlide = slide;
				}
			});
			slides.forEach(slide => {
				slide.style.height = tallestSlide.offsetHeight + 'px';
			});
		});
		slider.mount();
	}
}
window.app.add('slider', new slider());